import React, { Component } from 'react'
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";

import routes from "./routes"

export default class Routes extends Component {
    render() {
        return (
            <Router history={createBrowserHistory()}>
                <Switch>
                    {routes.map((route) => (
                        <Route
                            key={route.path}
                            path={route.path}
                            exact={route.exact}
                            component={route.component}
                        />
                    ))}
                    <Route path="/404" component={() => <div style={{
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: 200
                    }}>404</div>} />
                    <Redirect to="/404" />
                </Switch>
            </Router>
        )
    }
}